import React from 'react';
import Header from '../components/Header';
import Breadcrumb from '../components/Breadcrumb';
import ReferencesAndAuthor from '../components/ReferencesAndAuthor';
import Footer from '../components/Footer';
import { LAST_REVIEWED, formatarData } from '../data/revision';

function Sobre() {
  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-900">
      <Header />
      <Breadcrumb />
      <main className="max-w-5xl mx-auto px-4 py-12">
        <span className="section-kicker">Sobre o projeto</span>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight mt-2 mb-4 text-slate-800">Quem revisa a Escala de Glasgow online?</h1>
        <p className="text-lg text-gray-600 mb-8">Este site reúne calculadora, tabelas e conteúdo técnico sobre a Escala de Coma de Glasgow, com revisão médica identificada e processamento local das entradas.</p>

        <div className="grid md:grid-cols-2 gap-6">
          <section className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
            <h2 className="text-2xl font-bold mb-3">Qual é a proposta do site?</h2>
            <p className="text-gray-700">Servir como referência rápida para consulta dos componentes O, V e M, oferecer cálculo sem cadastro e explicar situações que geram erro de aplicação, como itens não testáveis, avaliação pediátrica e ECG-P.</p>
          </section>

          <section className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
            <h2 className="text-2xl font-bold mb-3">Como a calculadora funciona?</h2>
            <p className="text-gray-700">As seleções são processadas no navegador. O total só é exibido quando O, V e M são testáveis; se houver componente NT, o registro deve permanecer por componentes.</p>
          </section>

          <section className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
            <h2 className="text-2xl font-bold mb-3">Quais fontes orientam o conteúdo?</h2>
            <p className="text-gray-700">A base editorial inclui a publicação original de Teasdale e Jennett, a revisão de 40 anos da ECG, o trabalho de Brennan, Murray e Teasdale sobre ECG-P e o material oficial da Glasgow Coma Scale.</p>
            <a className="text-teal-700 font-semibold inline-block mt-3" href="/referencias">→ Ver referências completas</a>
          </section>

          <section className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
            <h2 className="text-2xl font-bold mb-3">Quando o conteúdo foi revisado?</h2>
            <p className="text-gray-700">Última revisão técnica: <strong>{formatarData(LAST_REVIEWED)}</strong>. A data só é atualizada quando há revisão real do conteúdo clínico.</p>
          </section>
        </div>

        <section className="bg-slate-900 text-white rounded-2xl p-6 md:p-8 mt-8">
          <h2 className="text-2xl font-bold text-white mb-3">Privacidade por arquitetura</h2>
          <p className="text-slate-100">A calculadora não exige nome, e-mail ou cadastro. O cálculo ocorre no navegador; valores selecionados não são enviados por formulário para um servidor do site.</p>
          <a className="underline inline-block mt-3" href="/privacidade">Ler política de privacidade</a>
        </section>

        <ReferencesAndAuthor />
      </main>
      <Footer />
    </div>
  );
}

export default Sobre;
